<template>
  <div>
    <div
      v-b-popover.hover.topright.html="getSpan( reviewerType , `${types[1]}`)"
      style="height: 100% !important; display: flex; align-items: center; justify-content: center;"
      class="hover-pointer text-center"
      @click="
        $router.push({
          name: 'assign-engineer',
          params: { id: data.item.id, type: `${types[0]}` },
          query: {
            certificate_name_en: data.item.certificate_name_en,
            sub_certificate_name: data.item.sub_certificate_name,
            request_code: data.item.request_code
          }
        })
      "
    >
      <span style="font-size: smaller;">
        {{ getSmallName(reviewerType) }}
      </span>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ReviewerCell',
  props: {
    data: {
      type: Object,
      required: false,
      default: null,
    },
    reviewerType: {
      type: String,
      default: null,
      required: false,
    },
    getSmallName: {
      type: Function,
      required: true,
    },
    getSpan: {
      type: Function,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
  },
}
</script>
